import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/lib/utils';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth'd
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Only verify the session cookie on admin routes; public visitors never hit /auth/me
    if (window.location.pathname.startsWith('/admin')) {
      checkAuth();
    } else {
      setUser(false);
      setLoading(false);
    }
  }, []);

  const checkAuth = async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    } finally {
      setChecked(true);
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {
      if (process.env.NODE_ENV === 'development') console.error('[Auth] logout request failed:', e);
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, checked, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
